<template>
  <div class="d-flex">
    <div
      :style="'width: calc(100vw - ' + screenWidth + 'px);'"
      class="pr-4 todo-view-container"
    >
      <div class="d-flex justify-content-between">
        <div class="title">
          To-Do List
        </div>
        <div class="new-todo-button" @click="showAddEditNewTodo = true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
          >
            <path
              d="M9.33333 5.66665H5.33333V9.66665H4V5.66665H0V4.33331H4V0.333313H5.33333V4.33331H9.33333V5.66665Z"
              fill="white"
            />
          </svg>
          New To-Do
        </div>
      </div>

      <div class="d-flex mb-3 flex-wrap filters">
        <div class="mr-4">
          <home-dropdown-selector
            v-model="filters.categories"
            :options="categoryOptions"
            theme="category"
            :hideSearch="true"
          />
        </div>
        <div class="mr-4">
          <home-dropdown-selector
            v-model="filters.assignedToIds"
            :options="assignedToOptions"
            theme="Assigned to"
          />
        </div>
        <div class="other-filters">
          <custom-home-filters
            :categories="extraFilterOptions"
            v-model="selectedExtraFilters"
            :showing="showing"
          />
        </div>
      </div>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between pagination align-items-center mb-2"
          >
            <div class="d-flex">
              <a
                class="hover-pointer"
                style="font-size: 14px"
                @click="fetchTasks"
              >
                <i class="fa fa-refresh"></i>
                <span class="ml-2 text-primary" style="font-size: 14px"
                  >Refresh</span
                >
              </a>
              <div
                class="border-left border-med-light-gray pl-1 ml-1 mr-1"
                style="width: 1px; height: 19px"
              ></div>
              <a
                class="hover-pointer"
                :class="
                  `${
                    selectedTasks.length > 0
                      ? `text-primary`
                      : `color-custom-dark-grey`
                  }`
                "
                style="font-size: 14px"
                @click="
                  () => {
                    selectedTasks.length > 0 && completeSelectedDocuments();
                  }
                "
              >
                <i class="fa fa-check-circle"></i>
                <span class="ml-2" style="font-size: 14px"
                  >Complete selected docs</span
                >
              </a>
            </div>
            <top-paginator
              :total="filters.totalCount ?? 0"
              :page="filters.page"
              :per-page="filters.pageSize"
              @change-page="changePage"
              class="custom-paginator flex-grow-2"
            />
          </div>
        </b-col>

        <b-col cols="12">
          <div @click="handlerClic">
            <custom-table
              ref="mainTable"
              v-model="selectedTasks"
              :items="items"
              :fields="fields"
              borderless
              no-left-padding
              @complete="complete"
              @sortData="handleSortData"
              :dismission-level="dismissionLevel"
            >
            </custom-table>
          </div>
          <div class="todo-overview-stats">
            <span class="principal-stats"
              >To-Do Items: {{ generalStats.total }}</span
            >
            <span class="ml-1"
              >(Create: {{ generalStats.createDocument }},</span
            >
            <span class="ml-1"
              >Complete: {{ generalStats.completeDocument }},</span
            >
            <span class="ml-1"
              >Sign & Complete : {{ generalStats.signAndComplete }},</span
            >
            <span class="ml-1">Manual: {{ generalStats.manual }})</span>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="d-none d-lg-block" style="width: 400px;">
      <div>
        <b-row>
          <div class="title ml-3">Notifications</div>
        </b-row>
        <custom-notifications />
      </div>
    </div>
    <to-do-add-edit-modal
      v-model="showAddEditNewTodo"
      @onHidden="closeModal"
      @onModify="() => fetchTasks(true)"
      :options="users"
    />
    <documents-mass-edit-modal
      v-if="documentMassEditModalShow"
      v-model="documentMassEditModalShow"
      :documentIds="selectedDocumentsIds"
      @onModify="
        () => {
          this.fetchTasks(true);
          this.documentMassEditModalShow = false;
          this.$refs.mainTable.clearSelected();
        }
      "
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import SelectInput from "../controls/SelectInput.vue";
import CustomTable from "../controls/CustomTable.vue";
import HomeDropdownSelector from "./HomeDropdownSelector.vue";
import CustomNotifications from "./CustomNotifications.vue";
import ToDoAddEditModal from "./ToDoAddEditModal.vue";
import taskServer from "../../server/tasks";
import { mapState, mapActions, mapGetters } from "vuex";
import TopPaginator from "../controls/TopPaginator.vue";
import userServer from "../../server/user";
import CustomHomeFilters from "./CustomHomeFilters.vue";
import DocumentsMassEditModal from "../document_archive/DocumentsMassEditModal.vue";
import { getSidebarCollapsed } from "../../helpers/session";
import { formatUser } from "../../helpers/user";

export default defineComponent({
  name: "ToDoIndex",
  props: ["showing"],
  components: {
    SelectInput,
    CustomTable,
    HomeDropdownSelector,
    CustomNotifications,
    ToDoAddEditModal,
    TopPaginator,
    CustomHomeFilters,
    DocumentsMassEditModal
  },
  data() {
    return {
      initializing: true,
      showAddEditNewTodo: false,
      selectedTasks: [],
      selectedTaskId: null,
      filters: {
        page: 0,
        pageSize: 50,
        search: "",
        documentTypes: [],
        dateFrom: null,
        dateTo: null,
        totalCount: null,
        categories: [
          { value: 0, label: "Create" },
          { value: 1, label: "Complete" },
          { value: 2, label: "Sign & Complete" },
          { value: 3, label: "Manual To Do" }
        ],
        sortBy: "",
        orderByDescending: false,
        assignedToIds: [],
        patientIds: []
      },
      categoryFilter: [],
      items: [],
      fields: [
        { key: "selection", label: "" },
        {
          key: "date",
          label: "Date",
          sortable: true
        },
        { key: "patient", label: "Patient", sortable: true },
        {
          key: "description",
          label: "Task",
          sortable: true
        },
        { key: "category", label: "Category", sortable: true },
        { key: "assignedTo", label: "Assigned To", sortable: true },
        { key: "actions", label: "Action" }
      ].map(field => {
        return {
          ...field,
          class: `column column-${field.key}`
        };
      }),
      categoryOptions: [
        { value: 0, label: "Create" },
        { value: 1, label: "Complete" },
        { value: 2, label: "Sign & Complete" },
        { value: 3, label: "Manual To Do" }
      ],
      extraFilterOptions: [
        { value: "patient", label: "Patient" },
        { value: "dateRange", label: "Date Range" }
      ],
      users: [],
      dismissionLevel: null,
      selectedExtraFilters: [],
      data: [],
      eocs: [],
      documentMassEditModalShow: false,
      selectedDocumentsIds: [],
      sideBarCollapsed: getSidebarCollapsed(),
      allCategoriesCount: null
    };
  },
  async mounted() {
    await this.initializeUsers();
    this.fetchFormBuilderForms({ category: "main" });
    this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "showAlertError",
      "fetchCurrentUser"
    ]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    async initializeUsers() {
      await this.fetchCurrentUser();
      const seeAll = this.hasCurrentUserPermissionAccess(
        "others",
        "toDoItemsSeeAll"
      );

      this.filters.assignedToIds =
        this.currentUser.role.name != "Tech Staff"
          ? [
              {
                value: this.currentUser.id,
                label: formatUser(this.currentUser)
              }
            ]
          : [];

      if (seeAll) {
        await this.fetchAllUsers();
        this.dismissionLevel = "full";
      } else if (
        this.currentUser.role.name != "Tech Staff" &&
        this.currentUser.isSupervisor
      ) {
        await this.getUserSupervisees();
      } else if (this.currentUser.role.name != "Tech Staff") {
        this.users = [this.currentUser];
      }
      this.initializing = false;
      this.fetchTasks(true, true);
    },
    async fetchTasks(instant, hideLoading = false) {
      if (this.initializing) {
        return;
      }
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      this.lastTimeout = setTimeout(
        async () => {
          try {
            const tasks = await taskServer.query(
              {
                page: this.filters.page,
                pageSize: this.filters.pageSize,
                assignedToIds:
                  this.filters.assignedToIds.length > 0
                    ? this.filters.assignedToIds.map(assigned => assigned.value)
                    : [],
                categories: this.filters.categories.map(cat => cat.value),
                orderBy: this.filters.sortBy,
                orderByDescending: this.filters.orderByDescending,
                patients: this.filters.patientIds,
                dateFrom: this.filters.dateFrom,
                dateTo: this.filters.dateTo
              },
              {
                "Hide-Loading": hideLoading
              }
            );
            this.items = tasks.toDoItems.map(item => ({
              id: item.id,
              date: this.formatDateOnly(item.date),
              patient: item.episodeOfCare
                ? item.episodeOfCare.mrnEocn +
                  " " +
                  item.episodeOfCare.patientFullName
                : "",
              description: item.description,
              category: this.getCategoryString(item.category),
              assignedTo: item.assignedToUser.fullName,
              document: item.document
            }));
            this.allCategoriesCount = {
              completeDoc: tasks.finalizeDocCount,
              createDoc: tasks.createDocCount,
              signAndComplete: tasks.completeDocCount,
              manual: tasks.manualCount,
              total: tasks.totalCount
            };
            this.filters.totalCount = tasks.totalCount;
          } catch (error) {
            this.showAlertError();
          }
        },
        instant ? 0 : 2000
      );
    },
    getCategoryString(category) {
      switch (category) {
        case 0:
          return "Create";
        case 1:
          return "Complete";
        case 2:
          return "Sign & Complete";
        case 3:
          return "Manual To Do";
      }
    },
    async changePage(page) {
      this.filters.page = page;
      await this.fetchTasks();
    },
    async complete(data) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to complete this item?"
          },
          {
            view: "confirm",
            removeButtonTitle: "Complete"
          }
        )
        .then(async () => {
          const { id } = data.item;
          const response = await taskServer.dismiss(id);
          if (response.id) {
            this.showAlertSuccess();
            await this.fetchTasks(true);
          }
        });
    },
    completeSelectedDocuments() {
      this.selectedDocumentsIds = this.selectedTasks.map(
        task => task.document.id
      );
      this.documentMassEditModalShow = true;
    },
    closeModal() {
      this.showAddEditNewTodo = false;
    },
    handleSortData(data) {
      const { sortBy, sortDesc } = data;
      this.filters.sortBy = sortBy;
      this.filters.orderByDescending = sortDesc;
    },
    async fetchAllUsers() {
      const users = await userServer.getFilteredUsers();
      this.users = users;
    },
    async getUserSupervisees() {
      const supervisees = await userServer.getSupervisees(this.currentUser?.id);
      this.users = [...supervisees, this.currentUser];
    },
    async handlerClic(event) {
      if (event.target.tagName === "A") {
        event.preventDefault();
        const dataValueId = event.target.parentNode.getAttribute(
          "data-todo-item"
        );
        this.checkDocument(dataValueId, event.target.href);
      }
    },
    async checkDocument(id, dataHref) {
      try {
        var status = await taskServer.getStatus(id);
        if (status) {
          this.$dialog
            .alert({
              title: "This document has already been created."
            })
            .then(() => {
              this.fetchTasks(true, true);
            });
        } else {
          window.location.href = dataHref;
        }
      } catch (error) {
        this.showAlertError();
      }
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      documentView: state => state.documentView,
      documentEditor: state => state.documentEditor,
      sidebarChange: state => state.sidebarChange
    }),
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"]),
    screenWidth() {
      return this.sideBarCollapsed ? "500" : "681";
    },
    generalStats() {
      const total = this.allCategoriesCount?.total || 0;
      const createDocument = this.allCategoriesCount?.createDoc || 0;
      const manual = this.allCategoriesCount?.manual || 0;
      const signAndComplete = this.allCategoriesCount?.signAndComplete || 0;
      const completeDocument = this.allCategoriesCount?.completeDoc || 0;

      return {
        total,
        createDocument,
        manual,
        signAndComplete,
        completeDocument
      };
    },
    assignedToOptions() {
      return this.users?.map(user => {
        return {
          label: formatUser(user),
          value: user.id
        };
      });
    }
  },
  watch: {
    showing: {
      handler: async function(value) {
        if (value) {
          await this.fetchTasks(true, false);
        }
      },
      immediate: true
    },
    "filters.categories": {
      handler: async function(val) {
        if (val) {
          this.filters.page = 0;
          await this.fetchTasks();
        }
      },
      deep: true
    },
    "filters.sortBy": {
      handler: async function(val) {
        if (val) {
          this.filters.page = 0;
          await this.fetchTasks(true);
        }
      },
      deep: true
    },
    "filters.orderByDescending": {
      handler: async function() {
        this.filters.page = 0;
        await this.fetchTasks(true);
      },
      deep: true
    },
    "filters.assignedToIds": {
      handler: async function() {
        this.filters.page = 0;
        await this.fetchTasks(false);
      },
      deep: true
    },
    "filters.patientIds": {
      handler: async function() {
        await this.fetchTasks();
      },
      deep: true
    },
    selectedExtraFilters: {
      handler: function(value) {
        this.filters.patientIds = value
          .filter(item => item.category === "Patient")
          .map(item => item.value);

        const dateRange = value.filter(item => item.category === "Date Range");

        if (dateRange.length > 0) {
          if (dateRange[0].startDate) {
            this.filters.dateFrom = new Date(dateRange[0].startDate);
          }
          if (dateRange[0].endDate) {
            var dateTo = new Date(dateRange[0].endDate);
            if (dateTo) {
              dateTo.setHours(23, 59, 59, 999);
            }
            this.filters.dateTo = dateTo;
          }
        } else {
          this.filters.dateFrom = null;
          this.filters.dateTo = null;
        }
        this.filters.page = 0;
      },
      deep: true
    },
    documentView: {
      handler: async function(value) {
        if (!value) {
          this.fetchTasks(true);
        }
      },
      immediate: true
    },
    documentEditor: {
      handler: async function(value) {
        if (!value) {
          this.fetchTasks(true);
        }
      },
      immediate: true
    },
    sidebarChange: function(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.sideBarCollapsed = getSidebarCollapsed();
        }, 500);
      }
    }
  }
});
</script>

<style lang="scss">
.title {
  color: #363abb;
  font-family: Bahnschrift;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 18px;
  margin-top: 28px;
}

.new-todo-button {
  cursor: pointer;
  margin-top: 25.5px;
  color: var(--white, #fff);
  font-family: Bahnschrift;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  height: 32px;
  padding: 0px 14px;
  align-items: center;
  gap: 9px !important;
  flex-shrink: 0 !important;
  border-radius: 5px !important;
  background: #363abb !important;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.25) !important;
}

.filters {
  margin-bottom: 18px;
}

.notification {
  :hover {
    border-radius: 8px;
    background: #363abb;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.17);
    color: var(--white, #fff);
    font-family: Bahnschrift;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    line-height: normal;
  }
}

.complete-docs {
  cursor: pointer;
  color: #363abb;
  font-family: Bahnschrift;
  font-size: 14px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  text-decoration-line: underline;
}

.custom-paginator {
  color: #3e3e3e;
  font-family: Bahnschrift;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  i {
    font-size: 14px !important;
  }
}

.pagination {
  width: 100%;
}

.todo-overview-stats {
  color: #646a7a;
  font-family: Bahnschrift;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 8px;
}
.principal-stats {
  color: #363abb;
  font-weight: 700;
}
.disabled-text {
  color: #adb1b4;
  font-family: Bahnschrift;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
}

@media (max-width: 1500px) {
  .filters {
    gap: 10px;
  }

  .other-filters {
    min-width: 100% !important;
  }

  .todo-view-container {
    width: 75% !important;
  }
}
</style>
